var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 3.667h3.333V5h-1.333v8.667a.666.666 0 01-.667.666H3.333a.667.667 0 01-.667-.666V5H1.333V3.667h3.333V2.333a.667.667 0 01.667-.666h5.333a.666.666 0 01.667.666v1.334zM12 5H4v8h8V5zM6 7h1.333v4H6V7zm2.666 0H10v4H8.666V7zM6 3v.667h4V3H6z",
    fill: "#58657C"
  })));
}
export default SvgDelete;